/* eslint-disable no-unused-expressions */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./style.css";
import "react-toastify/dist/ReactToastify.css";
// Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-grid.css";
// Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import store from "./redux/store";

// IMPORT THE TOAST PROVIDER
import { GlobalToastProvider } from "./stopOldToastGlobally"; // Make sure path is correct

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      {/* ADD GLOBAL TOAST PROVIDER HERE */}
      <GlobalToastProvider>
        <App />
      </GlobalToastProvider>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();